import { AUTH_ROUTE_PATHS } from "./authRoutePaths";
import { getAuthProvider } from "./providers";

export { AUTH_ROUTE_PATHS };

export const AUTH_CONTROL_PATHS = new Set(Object.values(AUTH_ROUTE_PATHS));

// Where to send a user who cannot proceed (expired account, failed setup). See
// blockedPath on each provider.
export const getBlockedAuthPath = (appSettings) => {
  return getAuthProvider(appSettings).blockedPath;
};

export const ENGAGE_AUTH_HOSTS = new Set([
  "engage.toyota.com",
  "staging.engage.toyota.com",
  "test.nonprod.engage.toyota.com",
  "dev.nonprod.engage.toyota.com",
  "localhost",
  "127.0.0.1",
]);

export const isAuthControlPath = (pathname = "") => {
  return AUTH_CONTROL_PATHS.has(pathname);
};

export const getConfiguredAuthHosts = (appSettings) => {
  const configuredUrls = [
    appSettings?.hostUrl,
    appSettings?.auth?.forgerock?.loginPageUrl,
    appSettings?.redirect_uri,
    appSettings?.logout_uri,
  ].filter(Boolean);

  return configuredUrls.reduce((hosts, configuredUrl) => {
    try {
      const configuredHost = new URL(configuredUrl, globalThis.location.origin)
        .hostname;

      if (configuredHost) {
        hosts.add(configuredHost);
      }
    } catch (error) {
      console.warn("Ignoring malformed auth URL in app settings.", error);
    }

    return hosts;
  }, new Set(ENGAGE_AUTH_HOSTS));
};
